import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles
} from '@material-ui/core';
import { RepliconDialog } from '~/modules/common/components';
import {
  useTargetUtilizationSettings,
  usePutTargetUtilizationSettings
} from '../../hooks/useTargetUtilizationSettings';
import { TargetUtilizationAlert, TargetUtilizationInput } from './components';

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  }
}));

export const TargetUtilizationSettingsDialog = ({ open, onClose }) => {
  const classes = useStyles();
  const { targetUtilization } = useTargetUtilizationSettings();
  const { putTargetUtilizationSettings } = usePutTargetUtilizationSettings();

  const [value, setValue] = useState(targetUtilization);

  const handleSave = useCallback(() => {
    if (putTargetUtilizationSettings) {
      putTargetUtilizationSettings({ targetUtilization: value });
    }
    onClose();
  }, [value, putTargetUtilizationSettings, onClose]);

  const checkIsDirty = useCallback(() => value !== targetUtilization, [
    value,
    targetUtilization
  ]);

  return (
    <RepliconDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="target-utilization-settings-dialog-title"
      checkIsDirty={checkIsDirty}
      enableUnsavedChangesWarning
    >
      <DialogTitle id="target-utilization-settings-dialog-title">
        <FormattedMessage id="resourceManagementDashboard.targetUtilizationSettings.title" />
      </DialogTitle>
      <DialogContent className={classes.content}>
        <TargetUtilizationAlert value={value} />
        <TargetUtilizationInput value={value} onChange={setValue} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          <FormattedMessage id="button.cancel" />
        </Button>
        <Button onClick={handleSave} color="primary">
          <FormattedMessage id="button.save" />
        </Button>
      </DialogActions>
    </RepliconDialog>
  );
};

TargetUtilizationSettingsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default TargetUtilizationSettingsDialog;
